import { ApiCardType } from '@/core/generated/api';

/** Размеры карточек на экране услуг */
export const VOX_SERVICE_CARD_TYPES = [
    {
        id: ApiCardType.Big,
        name: 'Большая'
    },
    {
        id: ApiCardType.Small,
        name: 'Маленькая'
    },
];

